export default __webpack_public_path__ + "static/media/43.fedf36ae.jpg";